import LocalizedStrings from 'localized-strings';

interface InternationalTransferRecipientListLocale {
  createRecipient: string;
  noBeneficiaryForCurrency: string;
}

export default new LocalizedStrings<InternationalTransferRecipientListLocale>({
  en: {
    createRecipient: 'Create a beneficiary',
    noBeneficiaryForCurrency:
      'No registered beneficiaries eligible for {currency} transfers',
  },
  fr: {
    createRecipient: 'Créer un bénéficiaire',
    noBeneficiaryForCurrency:
      'Aucun bénéficiaire éligible aux virements en {currency} enregistré.',
  },
} as const);
